import { US_TIMEZONES } from '@jebel/constants';

export const US_TIMEZONES_OPTIONS = US_TIMEZONES.map(({ longName, shortName }) => ({
  label: longName,
  value: shortName,
}));
